/**
 * Plan uyarı anahtarlarının Türkçe karşılıkları — AYLIK ızgara ve HAFTALIK pano ORTAK kullanır.
 *
 * Neden ayrı dosya: bu sözlük yalnız ShiftPlanTab'de yaşarken haftalık pano ham enum
 * anahtarını (`no_assignment`, `pattern_gap` …) kullanıcıya olduğu gibi gösteriyordu.
 * Aynı uyarı iki ekranda iki farklı dille anlatılmamalı.
 *
 * Sunucudaki kaynak: apps/api/src/hr-warn.ts (ShiftWarning). Yeni bir uyarı eklenirse
 * buraya da eklenmeli; eksikse arayüz anahtarı çıplak gösterir (sessizce yutmaz).
 */
export const WARN_SHORT: Record<string, string> = {
  employee_missing: "personel yok", no_assignment: "plan yok", pattern_missing: "şablon yok",
  pattern_gap: "desen eksik", shift_inactive: "vardiya pasif", assignment_overlap: "çakışan atama",
  pattern_tesis_mismatch: "tesis uyuşmuyor",
};

export const WARN_TEXT: Record<string, string> = {
  employee_missing: "Personel kaydı çözülemedi (veri tutarsızlığı)",
  no_assignment: "Vardiya planı yok — ne rotasyon ataması ne varsayılan vardiya tanımlı",
  pattern_missing: "Atanmış şablon bulunamadı (silinmiş olabilir)",
  pattern_gap: "Şablonda bu sıra için slot tanımlı değil — desen eksik",
  shift_inactive: "Plandaki vardiya pasife alınmış",
  assignment_overlap: "Aynı güne birden çok atama düşüyor — en geç başlayan uygulandı",
  pattern_tesis_mismatch: "Şablonun tesisi personelin tesisiyle uyuşmuyor",
};

/** Uyarı anahtarını okunabilir cümleye çevirir; bilinmeyen anahtar olduğu gibi döner. */
export const warnText = (k: string): string => WARN_TEXT[k] ?? k;
